class Env {
    environment: string = process.env.NODE_ENV
    version: string = process.env.VUE_APP_VERSION
    apiUrl: string = process.env.VUE_APP_API_URL
    sentry: { enabled: boolean, dsn?: string } = {
        enabled: this.parse(process.env.VUE_APP_SENTRY_ENABLED, false),
        dsn: process.env.VUE_APP_SENTRY_DSN
    }

    // 2FA timer overrides (configurable via .env.local for development)
    twoFactorVerifyLockoutSeconds: number = this.parseInt(process.env.VUE_APP_TWOFACTOR_VERIFY_LOCKOUT_SECONDS, 900)
    twoFactorEmailLockoutSeconds: number = this.parseInt(process.env.VUE_APP_TWOFACTOR_EMAIL_LOCKOUT_SECONDS, 600)
    twoFactorResendCooldownSeconds: number = this.parseInt(process.env.VUE_APP_TWOFACTOR_RESEND_COOLDOWN_SECONDS, 120)

    get isDevelopment(): boolean {
        return this.environment === 'development'
    }

    get isProduction(): boolean {
        return this.environment === 'production'
    }

    private parse(value: any, fallback?: any): any {
        if (typeof value === 'undefined') {
            return fallback
        }

        return JSON.parse(value)
    }

    private parseInt(value: any, fallback: number): number {
        if (typeof value === 'undefined') {
            return fallback
        }

        const parsed = Number.parseInt(value, 10)
        return isNaN(parsed) ? fallback : parsed
    }
}

export default new Env()
